<template>

<app-table-cell class="cell-wrapper" :data-align="align" :border="border">

	<div v-for="(label, index) in labels" v-tooltip="label.tooltip" :style="{backgroundColor: '#' + label.colour}" :key="index" class="label" :data-type="label.type">{{ label.text }}</div>

</app-table-cell>

</template>

<script>

export default {

	props: ['labels', 'align', 'border']

}

</script>

<style scoped>

.cell-wrapper {
	padding: 0px;
    display: grid;
    padding-top: 0px!important;
    grid-template-columns: repeat(auto-fit, minmax(0px, 1fr));
    grid-gap: 5px;
}

.cell-wrapper[data-align="right"] {
	justify-content: end;
    grid-template-columns: repeat(auto-fit, minmax(0px, 128px));
}

.row.is-top .cell {
    padding-top: 5px!important;
}

.label {
	color: #fff;
	font-size: 14px;
    text-align: center;
	padding: 3px 6px;
	line-height: 20px;
	font-weight: 400;
	overflow: hidden;
	border-radius: 4px;
	background-color: #4082d3;
	white-space: nowrap;
	text-overflow: ellipsis;
}

.label[data-type="blue"] {
	background-color: #4082d3;
}

.label[data-type="grey"] {
	background-color: #999;
}

.label[data-type="green"],
.label[data-type="success"] {
	background-color: #4faa80;
}

.label[data-type="red"],
.label[data-type="danger"] {
	background-color: #c55b5b;
}

.label[data-type="yellow"],
.label[data-type="warning"] {
	background-color: #ffbe7a;
	color: #333;
}

</style>
